/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Nonstopay
 */
export class Nonstopay {
    /**
     *
     * @type {string}
     * @memberof Nonstopay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Nonstopay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Nonstopay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Nonstopay
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Nonstopay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Nonstopay
     */
    autoApprove: boolean;
}
